<template>
  <div class="base-spinner">
    <BaseLoader
      class="base-loader"
      :isFetching="true"
    />
  </div>
</template>

<script setup lang="ts">
import BaseLoader from '@/components/base/BaseLoader.vue';

</script>

<style scoped lang="scss">
@import "@/assets/style/variables.scss";

.base-spinner {
  width: 100%;
  height: 100%;
  background:rgba(256, 256, 256, .8);
  z-index: 99999;

  &,
  .base-loader {
    position: fixed;
  }

  .base-loader {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

</style>
